<template>
  <div>
    <app-form-holder>
      <!--  -->
      <div>
        <app-form-title title="Email Verification"> </app-form-title>
      </div>
      <!--  -->
      <!-- Login form -->
      <div v-loading="loading">
        <!-- Success -->
        <div v-if="verifiedEmail === true">
          <AppVerifyEmailSucc />
        </div>
        <!-- Reset Link is Not -->
        <div v-if="verifiedEmail === false">
          <AppVerifyEmailLinkWrong />
        </div>
        <!--  -->
      </div>
      <!--  -->
      <!--  -->
      <el-divider />
      <!--  -->
      <!-- Other links -->
      <div txt-center>
        <el-space
          w-100
          :fill="true"
          alignment="center"
          direction="vertical"
          :size="4"
        >
          <div>
            <router-link to="/login">
              <el-link type="primary">Sign In</el-link>
            </router-link>
          </div>
          <!--  -->
        </el-space>
      </div>
      <!--  -->
    </app-form-holder>
  </div>
</template>

<script lang="ts">
import img from "@/assets/illustrations/reset-password.svg";
import { ErrorUtil } from "@/shared";
import { AccountUtil } from "@/shared/vuex";
import { Lock, Message } from "@element-plus/icons";
import { Options, Vue } from "vue-class-component";
import AppVerifyEmailSucc from "./verify-email-succ.vue";
import AppVerifyEmailLinkWrong from "./verify-email-failed.vue";

@Options({
  title: "Verify Email",
  components: { Message, Lock, AppVerifyEmailSucc, AppVerifyEmailLinkWrong },
})
export default class extends Vue {
  img = img;
  loading = true;
  verifiedEmail = "";

  get key() {
    return this.$route.query.key;
  }

  mounted() {
    this.verifyEmail();
  }
  /**
   * @verify the key
   */
  verifyEmail() {
    this.loading = true;
    this.$api.main
      .get(`/v1/auth/verify-email/${this.key}`)
      .then((resp) => {
        this.verifiedEmail = true as any;
        this.$message({
          duration: ErrorUtil.duration,
          type: "success",
          message: "Successfully verified the email.",
        });
        AccountUtil.fetchCurrent(this.$store);
      })
      .catch((err) => {
        this.verifiedEmail = false as any;
        this.$message({
          duration: ErrorUtil.duration,
          type: "error",
          message: ErrorUtil.stringify(err, {
            message: "Could not verify your reset key.",
          }),
        });
      })
      .finally(() => (this.loading = false));
  }
}
</script>

<style lang="scss"></style>
